// The one-line scope note atop every Passing widget — states the comparison
// basis (positional minutes · peer group · minutes floor) so each independent
// tile is self-explanatory. Old Catalyst showed this once at the top of the
// whole passing tab; our widgets are separate, so each carries its own.

import { theme } from "../lib/theme.js";
import { passingScopeText, type PassingComparison } from "./usePassingComparison.js";

export default function PassingScope({ cmp }: { cmp: PassingComparison }) {
  return <div style={{ color: theme.inkFaint, fontSize: 11 }}>{passingScopeText(cmp)}</div>;
}
